<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="800"
    transition="spin-in-out-transition"
  >
    <v-card class="main-card" dark>
      <v-container>
        <v-row align="center">
          <v-col cols="6">
            <h4 class="text-h5 font-weight-bold text-center">
              Will you overwork today?
            </h4>
            <div class="text-center mt-5">
              <v-btn rounded light class="mr-5" @click="workOvertimeAndClose"
                >Yes</v-btn
              >
              <v-btn rounded color="error lighten-1" @click="checkoutAndClose"
                >No</v-btn
              >
            </div>
          </v-col>
          <v-col cols="6" class="py-10 px-5">
            <v-img
              src="@/assets/image/notification/template/working_time.png"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import WorkingTimeMixin from '@/mixin/WorkingTime/WorkingTimeMixin';
import templateMixin from './templateMixin';

export default {
  name: 'FinishWorking',
  mixins: [templateMixin, WorkingTimeMixin],
  props: {},
  methods: {
    async checkoutAndClose() {
      await this.checkout();
      this.close();
    },
    async workOvertimeAndClose() {
      await this.overwork();
      this.close();
    },
    close() {
      this.show = false;
    },
  },
};
</script>

<style scoped lang="sass">
.main-card
  background-image: linear-gradient(to right, #4cbff2 , #3fa6ff)
</style>
